import { getLocalTimeZone } from '@internationalized/date';
import type { PlumaDatePickerPreset } from '@customerio/pluma-components/react/utils/date-picker';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import { activityHistory, type ActivityHistoryKind, gatedIncludedDays } from '../utils/activity-history';
import { type ActivityHistoryPresets, lockedPresetTooltip, lockPresetsBefore } from '../utils/activity-history-presets';
import { useAddons } from './use-addons';
import { useOpenActivityHistoryAddon } from './use-open-activity-history-addon';
import { usePauseSafePermission } from './use-pause-safe-permission';

export function useActivityHistoryPresets(
  kind: ActivityHistoryKind,
  presets: PlumaDatePickerPreset[],
): ActivityHistoryPresets {
  const { account } = useAuth();
  const { data: addons } = useAddons();
  const canEditBilling = usePauseSafePermission('account/billing/edit');
  const openAddon = useOpenActivityHistoryAddon();
  if (!isFlexPlan(account) || addons == null) return { presets };
  if (addons.purchased.some((addon) => addon.product === 'data_retention')) return { presets };

  const offer = addons.available.find((addon) => addon.product === 'data_retention');
  return lockPresetsBefore(
    presets,
    activityHistory(kind, new Date(), gatedIncludedDays(account, kind)),
    getLocalTimeZone(),
    {
      tooltip: lockedPresetTooltip(offer?.price ?? null, canEditBilling),
      onUnlock: canEditBilling ? () => void openAddon() : undefined,
    },
  );
}
